import { Box, InputGroup, InputRightElement } from "@chakra-ui/react";
import { Marker, Cancel } from "@airhelp/icons";
import type { Airport } from "@airhelp/react";
import { AutocompleteInput } from "../../AutocompleteInput";
import type { ConnectingAirport } from "../../AutocompleteForm.d";

interface ConnectingAirportInputProps {
  setConnection: (airport: Airport, id: string) => void;
  onRemove: (id: string) => void;
  id: string;
  disabledAirports: Airport[];
}

interface ConnectingAirportInputsProps extends Omit<ConnectingAirportInputProps, "id"> {
  connections: Array<ConnectingAirport | Pick<ConnectingAirport, "id">>;
}

const ConnectingAirportInput = ({ disabledAirports, setConnection, onRemove, id }: ConnectingAirportInputProps) => (
  <Box>
    <AutocompleteInput
      placeholder="e.g. London or LHR"
      setAirportSelected={(airport) => setConnection(airport, id)}
      instanceId={`connection_airport_${id}`}
      disabledAirports={disabledAirports}
      icon={<Marker boxSize={6} />}
    />
    {/* TO DO: implement the button in DS once experiment is over and feature is implemented */}
    <InputGroup top={-12} zIndex={1}>
      <InputRightElement>
        <Cancel color="greyscale.500" boxSize={6} onClick={() => onRemove(id)} cursor="pointer" />
      </InputRightElement>
    </InputGroup>
  </Box>
);

export const ConnectingAirportInputs = ({
  disabledAirports,
  connections,
  onRemove,
  setConnection,
}: ConnectingAirportInputsProps) => <> {
    connections.map(({ id }) => (
      <ConnectingAirportInput
        key={id}
        id={id}
        onRemove={onRemove}
        setConnection={setConnection}
        disabledAirports={disabledAirports}
      />
    ))
  }</>
